import { useCallback, useRef } from 'react';
import type { Entity } from '../types';
import type { GoodsData } from '@banhala/ui-kit';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

export const useLogDisplayGoods = () => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  // bridge 직접 호출 대신 AnalyticsContext 자동 머지 wrapper 사용.
  // 호출 인자도 잘못된 shape({ logging })에서 정상 shape({ analytics, ably_only_log })로 정리.
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const logDisplayGoods = useCallback<
    NonNullable<FlatListProps<GoodsData & Entity>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ index, isViewable, item }) => {
        if (index === null || !isViewable) {
          return;
        }
        if (goodsItemLoggedList.current.includes(index)) {
          return;
        }
        goodsItemLoggedList.current.push(index);

        logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          analytics: item.logging.analytics,
          ably_only_log: item.logging.ably_only_log,
        });

        if (isNotNil(item.item.ad)) {
          bridge.logAdEvent({
            action: AdAction.DISPLAY,
            ad: item.item.ad,
          });
        }
      });
    },
    [logAnalyticsEvent],
  );

  return { logDisplayGoods };
};
